
import { Component, Prop, Vue } from 'vue-property-decorator'

import { Rally } from '@/lib/models/Rally'

import CommitChart from './CommitChart'
@Component({
  components: {
    CommitChart
  }
})
export default class RodeoPieChart extends Vue {
  @Prop({ required: true }) rally!: Rally;
  @Prop({ required: true }) rallyRound!: any;

  get sumRegistered () {
    return this.rallyRound.registered_cars +
      this.rallyRound.registered_bikes +
      this.rallyRound.registered_boats
  }

  get sumPaidAndFinished () {
    return this.rallyRound.paid_cars +
      this.rallyRound.paid_bikes +
      this.rallyRound.paid_boats +
      this.rallyRound.finished_cars +
      this.rallyRound.finished_bikes +
      this.rallyRound.finished_boats
  }

  get sumAvailable () {
    const sumAvailable = this.rallyRound.available_cars +
      this.rallyRound.available_bikes +
      this.rallyRound.available_boats
    return sumAvailable >= 0 ? sumAvailable : 0
  }

  get sumWaitlist () {
    return this.rallyRound.waiting_cars +
      this.rallyRound.waiting_bikes +
      this.rallyRound.waiting_boats
  }

  get sumMax () {
    return this.rallyRound.max_teams_1 +
      this.rallyRound.max_teams_2 +
      this.rallyRound.max_teams_3
  }
}
